import React, { memo } from "react";
// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
// utils
import { isEmpty } from "@swiggy-private/js-utils";
// types
import { ICouponCardTextBanner } from "@swiggy-private/cart-types";
// styles
import { Container, ImageContainer, TextContainer } from "./styles";
// constants
import { COUPON_TEXT_BANNER_DATA_TEST_ID as TEST_ID } from "@swiggy-private/cart-test-ids";

interface CouponTextBannerProps {
    data: ICouponCardTextBanner;
}

const CouponTextBanner = ({ data }: CouponTextBannerProps) => {
    if (isEmpty(data.iconUrl) || isEmpty(data.text?.title)) {
        return null;
    }

    return (
        <Container bgColor={data.bgColour} data-testid={TEST_ID.CONTAINER}>
            <ImageContainer data-testid={TEST_ID.IMAGE}>
                <Image cloudinaryId={data.iconUrl} cloudinaryWidth={100} width={"100%"} height={"100%"} />
            </ImageContainer>
            <TextContainer variant="V2.body3.neutral.medium" color="text_High_Emphasis" data-testid={TEST_ID.TEXT}>
                {data.text?.title}
            </TextContainer>
        </Container>
    );
};

export default memo(CouponTextBanner);
